const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

export const num = (n) => Number(n || 0).toLocaleString("id-ID");
export const rupiah = (n) => `Rp ${num(n)}`;
export const ceilMult = (n, m = 5) => Math.ceil((Number(n) || 0) / m) * m;
export const reserveQty = (n, pct = 30) => Math.ceil(((Number(n) || 0) * (100 + Number(pct))) / 100);

export const currentPeriod = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const periodLabel = (p) => {
  if (!p) return "-";
  const [y, m] = p.split("-");
  return `${MONTHS[Number(m) - 1]} ${y}`;
};

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" }) : "-";

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" }) : "-";

export const colLetter = (i) => {
  let s = "";
  let n = i + 1;
  while (n > 0) {
    const m = (n - 1) % 26;
    s = String.fromCharCode(65 + m) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
};

export const ROLE_LABEL = {
  superadmin: "Admin Utama",
  owner: "Pemilik (Owner)",
  admin: "Admin Rekap",
  operator: "Operator",
  viewer: "Viewer",
  supervisor: "Supervisor",
  collector: "Petugas Penarikan",
};

const SHORT = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
export const CUST_STATUS = { aktif: "AKTIF", berhenti: "BERHENTI", baru: "PELANGGAN BARU", aktif_kembali: "AKTIF KEMBALI" };
export const invNo = (inv) => `${inv.number}${inv.revision ? ` R${inv.revision}` : ""}`;
export const REV_STATE = { pending_permission: "MENUNGGU PERSETUJUAN EDIT", pending_proposal: "USULAN REVISI MENUNGGU", edit_granted: "IZIN EDIT DISETUJUI" };
export const REQ_KIND = { permission: "IZIN EDIT", proposal: "USULAN PERUBAHAN" };
export const REQ_STATUS = { pending: "MENUNGGU", approved: "DISETUJUI", rejected: "DITOLAK", cancelled: "DIBATALKAN PENGAJU", expired: "KEDALUWARSA" };
export const KIND_LABEL = { reguler: "ESTIMASI REGULER", pasokan_awal: "PASOKAN AWAL", tidak_ada: "TIDAK ADA PASOKAN" };
export const RECON_LABEL = { cocok: "COCOK", lebih: "SELISIH LEBIH", kurang: "SELISIH KURANG", belum: "BELUM DIREKONSILIASI", perlu_pemeriksaan: "PERLU PEMERIKSAAN" };
export const STAGE_LABEL = { draft: "DRAFT", diperiksa: "DIPERIKSA", ditutup: "DITUTUP" };
const pad2 = (n) => String(n).padStart(2, "0");
export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};
export const nextPeriod = (p) => {
  const [y, m] = p.split("-").map(Number);
  return m === 12 ? `${y + 1}-01` : `${y}-${pad2(m + 1)}`;
};
export const supplyLabelOf = (p) => {
  const n = nextPeriod(p);
  const [y, m] = n.split("-").map(Number);
  return `Pasokan untuk ${periodLabel(n)} (${fmtDate(`${n}-01`)} – ${fmtDate(`${n}-${pad2(new Date(y, m, 0).getDate())}`)})`;
};

export const shortPeriod = (p) => {
  const [y, m] = p.split("-");
  return `${SHORT[Number(m) - 1]} ${y.slice(2)}`;
};

export const ACTION_LABEL = {
  "login.berhasil": "Login berhasil",
  "login.gagal": "Login gagal",
  logout: "Logout",
  "akses.ditolak": "Akses ditolak",
  "harga.tambah": "Tambah harga",
  "harga.ubah": "Ubah harga",
  "harga.hapus": "Hapus harga",
  "pelanggan.tambah": "Tambah pelanggan",
  "pelanggan.ubah": "Ubah pelanggan",
  "pelanggan.hapus": "Hapus pelanggan",
  "alamat.tambah": "Tambah alamat",
  "alamat.ubah": "Ubah alamat",
  "alamat.hapus": "Hapus alamat",
  "rekap.simpan": "Simpan rekap",
  "estimasi.buat": "Buat estimasi",
  "estimasi.hapus": "Hapus estimasi",
  "invoice.generate": "Buat invoice",
  "invoice.ubah": "Ubah invoice",
  "invoice.sahkan": "Pengesahan invoice",
  "invoice.hapus": "Hapus invoice",
  "cetak.nota": "Cetak nota",
  "cetak.ulang": "Cetak ulang nota",
  ekspor: "Ekspor data",
  "perusahaan.ubah": "Ubah profil perusahaan",
  "perusahaan.ubah_logo": "Ubah logo",
  "pengguna.tambah": "Tambah pengguna",
  "pengguna.ubah": "Ubah pengguna",
  "user.ganti_password": "Ganti password",
  "admin.perusahaan_tambah": "Admin: tambah perusahaan",
  "admin.perusahaan_ubah": "Admin: ubah perusahaan",
  "admin.perusahaan_aktifkan": "Admin: aktifkan perusahaan",
  "admin.perusahaan_nonaktifkan": "Admin: nonaktifkan perusahaan",
  "admin.perusahaan_logo": "Admin: ubah logo",
  "admin.pengaturan_ubah": "Admin: ubah pengaturan",
  "impor.pelanggan": "Impor pelanggan",
  "impor.rekap": "Impor rekap",
  "pembayaran.catat": "Catat pembayaran",
  "petugas.tugaskan": "Tugaskan petugas penarikan",
  "petugas.cabut": "Cabut penugasan petugas",
  "petugas.ubah_penugasan": "Ubah penugasan petugas",
  "invoice.revisi": "Revisi invoice",
  "revisi.ajukan": "Ajukan revisi invoice",
  "revisi.setujui": "Setujui pengajuan revisi",
  "revisi.tolak": "Tolak pengajuan revisi",
  "revisi.batal_ajukan": "Batalkan pengajuan revisi",
  "revisi.izin_supervisor": "Ubah izin revisi supervisor",
  "pelanggan.status": "Ubah status pelanggan",
  "pasokan_awal.simpan": "Simpan pasokan awal",
  "pasokan_awal.hapus": "Hapus pasokan awal",
  "topup.catat": "Catat top up",
  "topup.koreksi": "Koreksi top up",
  "topup.batal": "Batalkan top up",
  "rekonsiliasi.konfirmasi": "Konfirmasi rekonsiliasi",
  "periode.diperiksa": "Periode ditandai DIPERIKSA",
  "periode.draft": "Periode kembali DRAFT",
  "pelanggan.pulihkan": "Pulihkan pelanggan",
  "pelanggan.hapus_permanen": "Hapus permanen pelanggan",
  "pelanggan.hapus_permanen_otomatis": "Hapus permanen otomatis (30 hari)",
  "level.tambah": "Tambah level kustom",
  "level.ubah": "Ganti nama level",
  "level.hapus": "Hapus level kustom",
  "invoice.batal": "Batalkan invoice",
  "hak_akses.ubah": "Ubah hak akses",
  "hak_akses.ubah_platform": "Ubah hak akses lintas perusahaan",
  "akses.masuk_perusahaan": "Masuk ke perusahaan",
  "akses.keluar_perusahaan": "Keluar dari perusahaan",
  "pembayaran.hapus": "Hapus pembayaran",
  "rekap.kunci": "Kunci rekap",
  "rekap.buka_kunci": "Buka kunci rekap",
  "rekap.ditolak_terkunci": "Ubah rekap ditolak (terkunci)",
  "perusahaan.desain_nota": "Ubah desain nota",
  "perusahaan.unggah_signature": "Unggah tanda tangan",
  "perusahaan.unggah_stamp": "Unggah stempel",
  "perusahaan.hapus_signature": "Hapus tanda tangan",
  "perusahaan.hapus_stamp": "Hapus stempel",
};

export const notaPreview = (code, extra, period) =>
  `${(code || "XX").toUpperCase()}${(period || currentPeriod()).split("-")[1]}${(extra || "").toUpperCase()}-0001`;
